import React from 'react'
import CardContainer from '../../utils/CardContainer'
import { Box, Button, CardContent, CardMedia, Typography } from '@mui/material'
import { MovingText } from '../../utils/MovingText'
import ProgressBar from '../student/ProgressBar'
import MainDialogBox from '../Dialog/MainDialogBox'
import { useDialog } from '../../hook/useDialog'
import ViewCourseDetail from '../student/ViewCourseDetail'
import useCourseIdStore from '../../../store/useCourseIdStore'
import { ImagePath, ImageRelativePath } from '../../constants'

const ApartCourseCard = ({ item }) => {
    const { title, start_date, end_date, category_name, cover_image} = item
       const { courseId, setCourseId } = useCourseIdStore();
        const { open: openDetail, handleClickOpen: handleOpenDetail, handleClose: handleDetailClose } = useDialog();
        const handleViewDetail= () => {
            setCourseId(item?.course_id);
            handleOpenDetail();
        }
    const details = [
        // { label: "trainer", value: instructor_name },
        // { label: "Batch", value: batch_name },
        { label: "From", value: start_date },

    ];

    const additionalDetails = [

        { label: "To", value: end_date },
        // { label: "Status", value: status, color: statusColor },
        // { label: "Facility", value: facility_name },
    ];
    return (
        <>
            <CardContainer>
                <CardMedia
                    sx={{
                        width: { lg: "35%", xs: "100%" },
                        borderRadius: "15px",
                        height: { lg: "auto", xs: "200px" }
                    }}
                    image={`${ImagePath}${ImageRelativePath}${cover_image}`}
                    alt={title}
                />
                <CardContent sx={{ flex: 1, px: { lg: "15px", xs: "0" } }}>

                    <Box sx={{ display: "grid", gridTemplateColumns: "auto max-content", alignItems: "center" }}>
                        <Box sx={{ minWidth: 0 }}>
                            <MovingText text={title} variant={"h5"} />
                            <Typography variant='h6' color='secondary.light'>{category_name}</Typography>
                        </Box>
                    </Box>
                    <Box sx={{ my: 1 }}>
                        {[details, additionalDetails].map((group, index) => (
                            <Box key={index}>
                                {group.map(({ label, value, color }, idx) => (
                                    <Typography key={idx} fontSize={"13px"} variant="body2" sx={color ? { color } : {}}>
                                        {label}: {value}
                                    </Typography>
                                ))}
                            </Box>
                        ))}
                    </Box>



                    <Box my={2}> <ProgressBar /></Box>

                    <Button variant='contained' fullWidth
                    onClick={handleViewDetail}
                    >
                        View Detail
                    </Button>
                </CardContent>
            </CardContainer>
            <MainDialogBox open={openDetail} handleClose={handleDetailClose}>
                <ViewCourseDetail ispurchase={true} />
            </MainDialogBox >
        </>


    )
}

export default ApartCourseCard